const parseUrlQueryString = (queryString: string) => {
  var query: any = {};
  var pairs = (
    queryString[0] === "?" ? queryString.substr(1) : queryString
  ).split("&");

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i].split("=");
    query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || "");
  }

  return query;
};

export const getUrlParamsFromLocation = (location: {
  search: string;
}): any | null | undefined => {
  if (!location || !location.search) {
    return undefined;
  }

  return parseUrlQueryString(location.search);
};

export const getReferralCodeFromLocation = (location: {
  search: string;
}): string | null | undefined => {
  const urlParams = getUrlParamsFromLocation(location);

  if (!urlParams) {
    return undefined;
  }

  const { referral } = urlParams;
  return referral;
};
